<template>
    <div class='admin main-content container'>
        <h3>View Non Web-ready Records</h3>
        <p>
            Some catalog records may be marked as non web-ready.
            These records will not appear in the search results when browsing the online catalog.
            If you would like to see non web-ready records appear in the search results select the option below.
        </p>

        <p class='text-danger'>
            This feature is intended for testing purposes only.
            Relationships between records will not appear until both records are web-ready
        </p>

        <p class='alert alert-info' role='alert'>
            Selecting an option below will create a cookie that expires after 24 hours.
        </p>

        <!-- Sorting toggle -->
        <div class='toggle'>
            <div class='sort btn-group' data-toggle='buttons'>
                <label @click='set(false, 1)' class='btn btn-default' :class="{'active': view_non_web_ready == 'false'}">
                    <input type='radio'>View Web-Ready Only
                </label>
                <label @click='set(true, 1)' class='btn btn-default' :class="{'active': view_non_web_ready == 'true'}">
                    <input type='radio' checked>View All Records
                </label>
            </div>
        </div>

        <p v-show='show_redirect' class='alert alert-success' role='alert'>
            You will be redirected to the catalog search in <strong>{{seconds}}</strong> seconds
        </p>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                view_non_web_ready: this.get(),
                show_redirect: false,
                seconds: 5
            }
        },
        methods: {
            // From https://www.w3schools.com/js/js_cookies.asp
            // simple function to set value of cookie
            set: function (cvalue, exdays) {
                var self = this

                // Set cookie
                this.view_non_web_ready = cvalue
                var d = new Date();
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = "view_non_web_ready=" + cvalue + ";" + expires + ";path=/";


                // Redirect to search page
                // fun little countdown timer
                this.show_redirect = true;
                var timer = setInterval(function() {
                    if(self.seconds == 0) {
                        clearInterval(timer)
                        self.$router.push('search')
                    }
                    self.seconds -= 1
                }, 1000)
            },
            // From https://www.w3schools.com/js/js_cookies.asp
            // simple function to fetch value of cookie
            get: function() {
                var name = "view_non_web_ready=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for(var i = 0; i <ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return false;
            }
        }
    }
</script>

<style scoped lang="scss">
  .admin {
    padding-top: 160px;

    /* apply if less than 992px (bootstrap large) */
    @media (max-width: 991px) {
      padding-top: 100px;
    }

    .toggle,
    .alert {
      margin-top: 30px;
    }
  }
</style>


